import { ofType } from "redux-observable"
import { mergeMap } from "rxjs"
import { Action } from "../actions/actions"
import { ACTION_TYPES } from "../actions/types"
import { InventoryLocationSelector } from "../selectors"
import { Service } from "../services/service"


export const fetchEpic = (action$) => {
    return action$.pipe(
        ofType(ACTION_TYPES.FETCH_LISTING),
        mergeMap(() => {
            return Service.fetchListing()
                .then(response => {
                    return Action.fetchListingSuccess(response.data)
                })
        })
    )
}

export const submitEpic = (action$, $state) => {
    return action$.pipe(
        ofType(ACTION_TYPES.SUBMIT),
        mergeMap(() => {
            const inventoryLocation = InventoryLocationSelector.getSingleInventory($state.value)
            if (inventoryLocation.id) {
                return Service.patch(inventoryLocation.id, inventoryLocation)
                    .then((res) => {
                        if (res.error){
                            return Action.submitFail(res.error.message)
                        }
                        return Action.submitSuccess() 
                    })  
            }
            else {
                return Service.create(inventoryLocation)
                    .then((res) => {
                        if (res.error){
                            return Action.submitFail(res.error.message)
                        }
                        return Action.submitSuccess()
                    })
            }
      
        })
    )
}

export const deleteEpic = (action$, $state) => {
    return action$.pipe(
        ofType(ACTION_TYPES.DELETE),
        mergeMap(() => {
            const inventoryLocation = InventoryLocationSelector.getSingleInventory($state.value)
            return Service.delete(inventoryLocation.id)
                .then((res) => {
                    if (res.error){
                        return Action.deleteFail(res.error.message)
                    }
                    return Action.deleteSuccess()
                })        
        })
    )
}


// WEBPACK FOOTER //
// ./src/state/inventory/location/epics/epics.ts